import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ActiveBrandService } from '@go-modules/services/active-brand';
import type { BrandImage } from '@go-modules/interfaces/brands/brand.interface';

@Component({
	selector: 'loading',
	templateUrl: 'loading.component.html',
	styleUrls: ['./loading.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class LoadingComponent {
	@Input() public height: string = '75px';
	@Input() public width: string = '75px';

	constructor (private activeBrandService: ActiveBrandService) {}

	public get spotLogo (): BrandImage {
		return this.activeBrandService.getSpotLogo();
	}
}
